import React from "react";
import { Switch, Route } from "react-router-dom";

// Pages
import Labtest from "./index";

// Not found
import Error404 from "../Error404";

export default ({ match }) => {
    return (
        <Switch>
            <Route exact path={match.path} component={Labtest} />
            <Route component={Error404} />
        </Switch>
    );
};
